import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
// 组件
import { Page, TextField, Button, DataTable, Card, Icon, Spinner, Badge, Pagination, Tooltip, Text, BlockStack } from '@shopify/polaris';
import DeleteModal from "../../../components/DeleteModal"
// 样式+图标
import KeywordsResearchDeleteIcon from '../../../assets/KeywordsResearchDeleteIcon'
import KeywordsResearchWriteIcon from '../../../assets/KeywordsResearchWriteIcon'
import KeywordsResearchAddRemarkFail from '../../../assets/KeywordsResearchAddRemarkFail'
import KeywordsResearchAddRemarkSuccess from '../../../assets/KeywordsResearchAddRemarkSuccess'
import CountJumpServiceBanner from '../../../components/CountJumpServiceBanner'
import EmptyTableTip from '../../../components/EmptyTableTip'
import ToastFunc from '../../../components/ToastFunc';
import FooterPageSelect from '../../../components/FooterPageSelect';
import { connect } from "react-redux";
import { QuestionMarkInverseMajor } from "@shopify/polaris-icons";
import './index.css';
import SkeltonLoading from '../../../components/SkeltonLoading';
// 接口
import { reqGetCompetitorKeywords, reqHandleKeywords, reqQueryCompetitorKeywords } from '../../../api';
import utils from '../../../utils/utils';
// import { store } from '../../../redux/store';
//翻译包
import Language from '../../../i18n/Language';
import { cloneDeep } from 'lodash';
const t = Language

let timerArr = [];

class indexClass extends Component {

  state = {
    showBanner: true,
    loading: true,
    loadingPage: true,
    table: [],
    dataTableRow: [],

    //查询链接
    richResultsUrl: '',
    //搜索停顿
    delay: 0,
    //控制定时请求
    isSendData: false,
    //在分析的链接个数 用于判断是否取消定时请求 0取消 不为0不取消
    anzlyzingArr: [],
    TextValue: '',

    //弹窗
    showToast: false,  //弹窗显示
    showToastText: '',  //弹窗文字
    showToastIserror: false, //弹窗是否错误

    tableInput: [],

    //删除弹窗开关
    openDeleteStatus: false,

    deleteArr: [],

    //删除保存状态
    delSaveStatus: false,

    //分析中状态
    AnalysisLoading: false,

    //是否显示空页面
    isEmpty: false,

    //分页
    page: 1,
    total: 0,
    hasPrevious: false,
    hasNext: true,
    size: 10,

    //记录点击修改的状态 true是文本框 false是文字或图标
    editStatus: [],

    //remark修改状态
    remarkStatus: [],

    userServices:'',

    current_PageSize: 10, // 表格条数

    isShowIssueBanner: this.props.isShowIssueBanner,
    analyzeError: '',
  };

  shouldComponentUpdate(nextProps) {
    if(nextProps.userServices !== this.props.userServices) {
      this.setState({
        userServices: nextProps.userServices
      })
    }

    if(nextProps.isShowCKBanner !== this.props.isShowCKBanner) {
      this.setState({
        isShowCKBanner: nextProps.isShowCKBanner,
        showBanner: nextProps.isShowCKBanner,
      })
    }

    return true;
  }

  componentDidMount() {
    this.getCompetitorKeywords().then((res) => {
      if (res !== 200) {
        // this.getDataEveryFiveSecond()
      }
    });
  }

  componentWillUnmount() {
    timerArr.map(timer => {
      clearInterval(timer);
      timerArr.pop();
      return false;
    })
    this.setState = () => false;
  }


  // 设置url input值
  handleUrlInputChange = (value, name) => {
    this.setState({
      richResultsUrl: value,
      analyzeError: '',
    })
  }

  // 提示弹窗
    toggleToast = (showToastText, showToastIserror) => {
        this.setState({
            showToast: false
        }, () => {
            this.setState(({ showToast }) => ({
                showToast: !showToast,
                showToastText: showToastText,
                showToastIserror: showToastIserror
            }));
        });
    };

  // 点击打开删除弹窗
  openDeleteModal = (id) => {

    //升级服务开关 
    if (this.props.userServices.CompetitorKeywords === false) {
      this.props.show();
      return;
    }

    this.setState({
      openDeleteStatus: true,
      deleteArr: id
    })
  }

  // 关闭删除弹窗
  CloseDeletePop = (val) => {
    this.setState({
      openDeleteStatus: val,
      deleteArr: []
    })
  }

  // 删除弹窗组件关闭 子组件传值到父组件
  DeleteChildrenChange = (val, deleteArr) => {//这个val就是子组件传来的
    this.setState({
      delSaveStatus: true
    })
    this.DeletedKeywords(deleteArr).then(res => {
      this.setState({
        openDeleteStatus: val,
        checked: false,
        delSaveStatus: false
      })
      this.getCompetitorKeywords()
    })
  }

  // 查询关键词
  queryCompetitorKeywords = async () => {
    //升级服务开关 
    if (this.props.userServices.CompetitorKeywords === false) {
      this.props.show();
      return;
    }

    if(this.state.richResultsUrl === '') {
      this.setState({
        analyzeError: "Please enter the web address.",
      })
    } else {
      this.setState({
        AnalysisLoading: true
      })
      const params = {
        website: this.state.richResultsUrl
      };
      const response = await reqQueryCompetitorKeywords(params);
      if (response.code === "200") {
        this.setState({
          AnalysisLoading: false,
          richResultsUrl: '',
        }, () => {
          this.getCompetitorKeywords();
          this.getDataEveryFiveSecond();
          this.toggleToast(response.msg, false);
        })
      } else {
        this.setState({
          AnalysisLoading: false,
          analyzeError: response.msg,
        }, () => {
          // this.toggleToast(response.msg, true);
        })
      }
    }

  }

  // 如果有Anzlyzing状态的数据 每5秒更新一次页面数据
  getDataEveryFiveSecond() {
    var timer = setInterval(function () {
      this.intervalGetCompetitorKeywords().then(function (response) {
        if (response === 200) {
          clearInterval(timer);
        }
      })
    }.bind(this), 5000);
    timerArr.push(timer);
  }

  handleSave = async (index, objs) => {
    var tableInput = this.state.tableInput
    tableInput[index] = this.state.tableInput[index]
    // 修改状态
    var remarkStatus = this.state.remarkStatus
    remarkStatus[index] = true
    this.setState({
      remarkStatus
    }, () => {
      this.updateCompetitorKeywords()
    })

    const params = {
      type: 1,
      id: objs['id'],
      remark: this.state.tableInput[index]
    }
    //如果修改后的值和之前的相同 则不请求
    let data = cloneDeep(this.state.table);
    if (objs['remark'] === this.state.tableInput[index]) {
      // this.toggleToast(t("No modification temporarily"), true);
      data.forEach(item => {
        if(item.id === objs.id) {
          item['errorTip'] = "No modification temporarily";
        }
      })
      this.setState({
        table: data
      }, () => {
        this.updateCompetitorKeywords()
      })
    } else if (this.state.tableInput[index].length > 100) {
      // this.toggleToast(t("Length must be less than 100"), true);
      data.forEach(item => {
        if(item.id === objs.id) {
          item['errorTip'] = "Length must be less than 100";
        }
      })
      tableInput[index] = objs['remark']
      this.setState({
        tableInput,
        table: data
      }, () => {
        this.updateCompetitorKeywords()
      })
    } else {
      const response = await reqHandleKeywords(params);
      if (response.code === "200") {
        this.getCompetitorKeywords(); //解决无及时更新
        this.toggleToast(t("Success"), false);
      } else {
        // this.toggleToast(response.msg, true);
        data.forEach(item => {
          if(item.id === objs.id) {
            item['errorTip'] = response.msg;
          }
        })
      }
      // var table = this.state.table
      data[index].remark = this.state.tableInput[index]
      this.setState({
        table: data,
      }, () => {
        this.updateCompetitorKeywords()
      })
      var editStatusArr = this.state.editStatus
      editStatusArr[index] = false
      this.setState({
        editStatusArr
      })
    }
    remarkStatus[index] = false
    this.setState({
      remarkStatus,
    }, () => {
      this.updateCompetitorKeywords()
    })
  }

  //输入框修改
  changeText = (index, objs, value) => {
    var tableInput = this.state.tableInput;
    tableInput[index] = value;

    let data = cloneDeep(this.state.table);
    data.forEach(item => {
      if(item.id === objs.id) {
        item['errorTip'] = '';
      }
    })

    this.setState({
      tableInput,
      table: data
    }, () => {
      this.updateCompetitorKeywords()
    })
  }

  //取消修改
  cancelUpdate = (index, objs) => {
    let data = cloneDeep(this.state.table);
    data.forEach(item => {
      if(item.id === objs.id) {
        item['errorTip'] = '';
      }
    })
    let editStatusArr = this.state.editStatus
    for (let i = 0; i < editStatusArr.length; i++) {
      if (index === i) {
        editStatusArr[i] = false
      }
      this.setState({
        editStatus: editStatusArr,
        table: data
      }, () => {
        this.updateCompetitorKeywords()
      })
    }
  }

  //点击添加备注评论
  addRemark = (index, id, remark, editStatus) => {

    //升级服务开关 
    if (this.props.userServices.CompetitorKeywords === false) {
      this.props.show();
      return;
    }
    let editStatusArr = this.state.editStatus
    editStatusArr[index] = true

    this.setState({
      editStatus: editStatusArr
    }, () => {
      this.updateCompetitorKeywords()
    })
  }

  updateCompetitorKeywords = () => {
    let keywordsList = this.state.table.map((item, index) => {
      let website = "";
      let status = "";
      let organic = "";
      let paid = "";
      let remark = "";
      let createtime;
      let nextUpdateTime;
      let del = "";
      website = <div style={{ gap: '.5rem', minWidth: '15rem', maxWidth: '15rem' }} title={item.website}>
        <div style={{ width: '100%', textOverflow: 'ellipsis', overflow: 'hidden', fontSize: '14px' }}>{item.website}</div>
      </div>;
      if (item.pok_status !== 2 || item.rok_status !== 2) {
        status = <span className='Anzlyzing badge_flex'>
          <Badge>
            {t("Anzlyzing")}
            <Spinner size="small" />
          </Badge>
        </span>
      } else {
        status = <Badge tone="success">{t("Done")}</Badge>
      }
      organic = item.rok_status !== 2 ? '-' :
        <span style={{ color: "#005BD3", cursor: 'pointer' }}
          onClick={() => {
            utils.routeJump(this, '/keywordRearch/keywords-research/Competitor-keywords-detail', {
              selectedType: 0,
              oid: item.rok_id,
              pid: item.pok_id,
              title: item.website,
            })
          }}>{item.rok_num}</span>;
      paid = item.pok_status !== 2 ? '-' :
        <span style={{ color: "#005BD3", cursor: 'pointer' }}
          onClick={() => {
            utils.routeJump(this, '/keywordRearch/keywords-research/Competitor-keywords-detail', {
              selectedType: 1,
              oid: item.rok_id,
              pid: item.pok_id,
              title: item.website,
            })
          }}>{item.pok_num}</span>;
      remark = this.state.editStatus[index] ?
        <div className="addRemarkStyle" style={{minWidth: '15rem'}}>
          <TextField
            value={this.state.tableInput[index]}
            onChange={this.changeText.bind(this, index, item)}
            autoComplete="off"
            error={item['errorTip']}
          />
          {this.state.remarkStatus[index] ? <span><Spinner size="small" /></span> :
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '.5rem' }}>
              <span className="WriteIcon" onClick={this.handleSave.bind(this, index, item)}><Icon source={KeywordsResearchAddRemarkSuccess} /></span>
              <span className="WriteIcon" onClick={this.cancelUpdate.bind(this, index, item)}><Icon source={KeywordsResearchAddRemarkFail} /></span>
            </div>}
        </div> : (item.remark ?
          <div style={{ cursor: "pointer", width: '20rem' }} title={item.remark} onClick={this.addRemark.bind(this, index, item.id, item.remark, this.state.editStatus[index])}>
            <div style={{ width: '100%', textOverflow: 'ellipsis', overflow: 'hidden' }}>{item.remark}</div>
          </div> :
          <span className='WriteIcon' style={{ cursor: "pointer" }} onClick={this.addRemark.bind(this, index, item.id, item.remark, this.state.editStatus[index])}>
            <Icon source={KeywordsResearchWriteIcon} />
          </span>);
      createtime = item.created_at;
      nextUpdateTime = item.updated_at;
      del = <span className='DeleteIcon' onClick={this.openDeleteModal.bind(this, [item.id])}>
            <Icon source={KeywordsResearchDeleteIcon}/>
        </span>;
      return ([
        website,
        status,
        organic,
        paid,
        remark,
        createtime,
        nextUpdateTime,
        del,
      ]);
    })
    this.setState({
      dataTableRow: keywordsList,
      isEmpty: keywordsList.length > 0 ? false : true //空页面判断
    })
  }

  //获取关键词列表
  getCompetitorKeywords = async () => {
    const params = {
      page: this.state.page,
      size: this.state.size,
    }
    const res = await reqGetCompetitorKeywords(params);
    if (res.code === 200) {
      const data = res.data.data;

      var editStatus = [];
      var tableInput = [];
      var remarkStatus = [];
      var anzlyzingArr = [];

      for (let i = 0; i < res.data.data.length; i++) {
        res.data.data[i]['errorTip'] = '';
        editStatus.push(false);
        remarkStatus.push(false);
        tableInput.push(res.data.data[i].remark);
        anzlyzingArr.push(res.data.data[i].status);
      }
      // 更新分页数据
      const maxPage = Math.ceil(res.data.count / this.state.size);
      var hasPrevious = ""
      var hasNext = ""
      //如果当前页面大于1 且 小于 总分页   上下都为开启
      if (this.state.page > 1 && this.state.page < maxPage) {
        hasPrevious = true;
        hasNext = true;
        //如果当前页面小于等于1 且 小于总分页 下关闭 上开启
      } else if (this.state.page <= 1 && this.state.page < maxPage) {
        hasPrevious = false;
        hasNext = true;
        //如果当前页面大于1 且 大于等于 总分页   下开启 上关闭
      } else if (this.state.page > 1 && this.state.page >= maxPage) {
        hasPrevious = true;
        hasNext = false;
        // 否则都关闭
      } else if (this.state.page <= 1 && this.state.page >= maxPage) {
        hasPrevious = false;
        hasNext = false;
      }

      this.setState({
        loadingPage: false,
        loading: false,
        table: data,
        total: res.data.count, //总关键词条数
        hasPrevious: hasPrevious,
        hasNext: hasNext,
        editStatus,
        tableInput,
        remarkStatus,
        anzlyzingArr
      }, () => {
        this.props.setLoadingPageCK();
        this.updateCompetitorKeywords()
      })

      if (anzlyzingArr.indexOf(false) === -1) {
        return 200
      }
    }
  }

  //定时更新数据
  intervalGetCompetitorKeywords = async () => {
    let anzlyzingArr = [];

    const params = {
      page: this.state.page
    }
    const res = await reqGetCompetitorKeywords(params);
    if (res.code === 200) {
      const data = res.data.data;


      for (let i = 0; i < res.data.data.length; i++) {
        anzlyzingArr.push(res.data.data[i].status);
      }

      this.setState({
        table: data,
        anzlyzingArr
      }, () => {
        this.updateCompetitorKeywords()
      })

      if (anzlyzingArr.indexOf(false) === -1) {
        return 200
      }
    }

    return anzlyzingArr.indexOf(false) === -1 ? 200 : 0
  }

  bannerStatus = (e) => {
    this.setState({
      showBanner: false
    }, () => {
      this.props.closeBannerObj(e);
    })
  }

  //删除
  DeletedKeywords = async (IDArr) => {
    const params = {
      type: 2,
      id: IDArr,
    }
    const response = await reqHandleKeywords(params);
    if (response.code === "200") {
      this.toggleToast(response.msg, false);
    } else {
      this.toggleToast(response.msg, true);
    }
  }

  // 选择表格条数
  changePageSize = (e) => {
    this.setState({
        page: 1,
        size: Number(e),
        current_PageSize: Number(e),
        loading: true,
    }, () => {
      this.getCompetitorKeywords()
    })
  }
  
  // 返回
  goBack = () => {
    utils.routeJump(this, '/keywordRearch')
  }

  render() {
    const {
        state: {
          showBanner,
          loading,
          dataTableRow, 
          richResultsUrl, 
          openDeleteStatus, 
          deleteArr, 
          delSaveStatus,
          AnalysisLoading,
          page,
          total,
          size,
          hasPrevious,
          hasNext,
          isEmpty,
          current_PageSize,
          analyzeError,
          
        },
        handleUrlInputChange,
        queryCompetitorKeywords,
        DeleteChildrenChange,
        CloseDeletePop,
        getCompetitorKeywords,
        changePageSize
    } = this;

    var showEmpty = "";
    if (total === 0) {
      showEmpty = <EmptyTableTip content={t("Nothing fits into the category")} overview={t("Please check elsewhere.")} mixheight={"400"} />
    }

    const toastMarkup = this.state.showToast ? <ToastFunc content={this.state.showToastText} onDismiss={this.state.showToast} error={this.state.showToastIserror} /> : null;

    const pageBanner = showBanner ? <div style={{ marginBottom: '1rem' }}><CountJumpServiceBanner form={4} closeBannerObj={this.bannerStatus} /></div> : null;

    const analysis = <div className='AnalysisBox'>
        <div className='AnalysisInput'>
          <TextField
            type="url"
            name='richResultsUrl'
            spellCheck={true}
            onChange={handleUrlInputChange}
            value={richResultsUrl}
            placeholder={t("Enter a website(like a competitor website)")}
            error={analyzeError}
          />
        </div>
        <div className='AnalysisButton' style={{ margin: '2px 0'}}>
          <Button variant="primary" disabled={loading} loading={AnalysisLoading} onClick={queryCompetitorKeywords}>{t("Analyze")}</Button>
        </div>
        <div className='keyword_btn_tip'>{t("After adding URLs, the system will complete the analysis within 24 hours.")}</div>
    </div>;

    const wwidth = this.props.public.window_width; // 屏幕宽度
    var footerContentMsg = "";
    if (total > 0) {
      const startNum = (page - 1) * size + 1;
      const endNum = page * size > total ? total : page * size;
      // footerContentMsg = t("Showing {{v1}} - {{v2}} of {{v3}} results", startNum, endNum, total);
      footerContentMsg = wwidth >= 550 ? <FooterPageSelect changePageSize={changePageSize} startNum={startNum} endNum={endNum} total={total} current_PageSize={current_PageSize} /> : t("Showing {{v1}} - {{v2}} of {{v3}} results", startNum, endNum, this.state.total);

    }

    const dataTable = <div className='dataTable'>
      <Card>
        {loading ? <div>
          <DataTable
          columnContentTypes={[
            "text",
            "text",
            "text",
            "text",
            "text",
            "text",
            "text",
            "text",
          ]}
          headings={[
            t("Website"),
            t("Status"),
            t("Organic keywords"),
            t("Paid keywords"),
            t("Remark"),
            t("Create time"),
            t("Next update time"),
            "",
          ]}
          rows={[]}
        />
        <div className="DetailReport_Empty_New_div_margin_600">
          <Spinner size="large" color="teal" />
        </div>
      </div> : <div>
          <DataTable
            columnContentTypes={[
              "text",
              "text",
              "text",
              "text",
              "text",
              "text",
              "text",
              "text",
            ]}
            headings={[
              t("Website"),
              t("Status"),
              t("Organic keywords"),
              t("Paid keywords"),
              t("Remark"),
              t("Create time"),
              t("Next update time"),
              "",
            ]}
            rows={dataTableRow ? dataTableRow : []}
          />
          {isEmpty ? showEmpty : ''}
          {!isEmpty ? <div className={`justify_center ${current_PageSize > 5 && dataTableRow.length > 5 ? 'sticky_footer' : ''}`}>
            <Pagination
              label={footerContentMsg}
              hasPrevious = {hasPrevious}
              onPrevious={() => {
                this.setState(({
                  page: page - 1,
                  loading: true
                }), () => {
                  //重新请求列表
                  getCompetitorKeywords();
                });
              }}
              hasNext={hasNext}
              onNext={() => {
                this.setState(({
                  page: page + 1,
                  loading: true
                }), () => {
                  //重新请求列表
                  getCompetitorKeywords();
                });
              }}
            />
          </div> : ''}
        </div>}
      </Card>
    </div>

    const pagesContent = <div className='CompetitorKeywordsContent'>
      {pageBanner}
      {analysis}
      {dataTable}
      <DeleteModal
        open={openDeleteStatus}
        delSaveStatus={delSaveStatus}
        deleteArr={deleteArr}
        CloseDeletePop={CloseDeletePop}
        changeData={DeleteChildrenChange}
      />
    </div>;

    // 判断是否shopify内嵌模式
    // const shopifyMode = store.getState().public.isShowTopMenu;

    // 底部
    // const FooterHelpBox = <FooterTrustHelp />
    
    // 最终内容
    var pageContentLast = this.state.loadingPage ? <SkeltonLoading /> :
      <Page
        title={<div style={{ display: "flex", alignItems: "center" }}>
          {t("Competitor Keywords Research")}
        </div>}
        backAction={{
          content: t("Competitor Keywords Research"),
          onAction: this.goBack,
        }}
      >
        <title>SEOAnt - Competitor Keywords Research</title>
        <BlockStack gap={600}>
          <div className='flex_layout keyword_title' style={{ columnGap: 0 }}>
            <Text variant="headingMd" as="h2">{t("Competitor Keyword Analysis")}</Text>&nbsp;
            <Tooltip content={t("Analyze your competitors' keywords and identify content gaps to enhance your SEO content strategy.")}>
              {<Icon backdrop source={QuestionMarkInverseMajor} />}
            </Tooltip>
          </div>
          {pagesContent}
        </BlockStack>

        {/* 底部 */}
        {/* {FooterHelpBox} */}

        {/* 通知 */}
        {toastMarkup}
      </Page>

    return (
      <div>
          {pageContentLast}
      </div>
    );
  }
}


const mapStateToProps = state => {
  return state
}

indexClass = connect(
  mapStateToProps,
)(indexClass);

export default withRouter(indexClass);